<script setup lang="ts">
import type { PolicyMenuItem } from '~/components/menu/MenuTypes';

defineProps<{
  link: PolicyMenuItem,
  icon?: string[],
  dataCy?: string,
  isSelected?: boolean
}>();

const { setSlideoverState } = useSlideoverToggle();
</script>

<template>
  <li class="mt-4 relative hover:font-semibold hover:transition-100">
    <NuxtLink :href="link.url" :data-cy="dataCy" @click="setSlideoverState(false)">
      <span
        :class="[
          { 'text-(--ui-primary) font-semibold': isSelected },
          'hover:text-(--ui-primary) flex items-center',
        ]"
      >
        <UiFaIcon v-if="icon" :icon="icon" />
        <UiFaIcon
          v-if="isSelected && !icon"
          :icon="['fal', 'angle-right']"
          class="w-[15px] absolute top-[4px] -left-[15px]"
        />
        <span class="ml-2">
          <slot name="link-name">
            {{ link.name }}
          </slot>
        </span>
      </span>
    </NuxtLink>
  </li>
</template>
